<template>
  <div
    ref="$overlay"
    class="nav-overlay"
    :class="[
      overlayName,
      {
        shown: isActive,
        'disable-media-rail': experiments.disableMediaRail,
        'nav-overlay--transparent': isMobile && killswitches.masterMewWhitespaceRemovalEnabled,
      },
    ]"
    :style="{ height: overlayHeight }"
    @click="handleClick"
  ></div>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { ref, computed } from 'vue';
import { useEventBus } from '@vueuse/core';
import { GET_IS_ACTIVE_OVERLAY, GET_OVERLAY_NAME, GET_ATTRS, GET_IS_MOBILE_VIEW } from '#shared/types/getters';
import { OVERLAY, events } from '#shared/constants/eventBus';
import { useDocumentHeight } from '~/composables/dumb/useDocumentHeight';
import useExperiments from '~/composables/useExperiments';
import useKillswitches from '~/composables/useKillswitches';

const navHeader = useNavHeader();
const navOverlay = useNavOverlay();
const navViewType = useNavViewType();

const $overlay = ref(null);
const experiments = useExperiments();
const killswitches = useKillswitches();

const isMobile = computed(() => navViewType[GET_IS_MOBILE_VIEW]);
const isActive = computed(() => navOverlay[GET_IS_ACTIVE_OVERLAY]);
const overlayName = computed(() => navOverlay[GET_OVERLAY_NAME]);
const documentHeight = useDocumentHeight();
const overlayHeight = computed(() => {
  if (!isActive.value || !documentHeight.value) return 0;

  const offsetTop = $overlay.value?.getBoundingClientRect().top || 0;
  const baseHeight = documentHeight.value - navHeader.skipToContentOffset - offsetTop;
  const minimalFooterHeight = 82;
  const height = navHeader[GET_ATTRS].isMinimal ? baseHeight + minimalFooterHeight : baseHeight;

  return `${height}px`;
});

const bus = useEventBus(OVERLAY);
function handleClick() {
  bus.emit(events[OVERLAY].CLICK);
}
</script>

<style lang="scss" scoped>
.nav-overlay {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  background-color: $overlay-color;
  z-index: 5;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.25s linear 50ms;

  &.shown {
    visibility: visible;
    opacity: 1;
  }

  &.search-modal {
    top: 0;
    background-color: $white;
    transition: none;
  }

  &.nav-overlay--transparent {
    background-color: $overlay-color;
  }

  @include breakpoint(large up) {
    &.search-modal {
      background-color: $overlay-color;
      transition: opacity 0.25s linear 50ms;
    }
  }

  @include breakpoint(medium down) {
    &.mobile-navigation {
      top: 0;
    }
  }
}
</style>

<style lang="scss" brand="mcom" scoped>
.nav-overlay {
  &.link-rail {
    top: 43px;
  }

  &.quick-bag {
    top: 112px;
    z-index: 5;
  }

  &.navigation {
    top: 180px;
    z-index: 5;
  }

  @include breakpoint(medium down) {
    &.search-modal {
      z-index: 22;
    }
  }
}
</style>

<style lang="scss" brand="bcom" scoped>
.nav-overlay {
  &.link-rail {
    top: 80px;
  }

  &.link-rail.disable-media-rail {
    top: 40px;
  }
}
</style>
